import React from 'react';
import { Translate } from 'react-localize-redux';

export class TimeStamp extends React.Component {
    overXHoursAgo = hours =>
        <Translate>
            {({ translate }) => <span>{translate('over_x_hours_ago').replace('{0}', hours)}</span>}
        </Translate>;

    getTimeStamp(activityTime) {
        var date_now = new Date();
        activityTime = new Date(activityTime);

        var seconds = Math.floor(((date_now) - activityTime) / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        if (hours < 1) {
            if (minutes < 2) {
                return <Translate id='one_minute_ago' />;
            } else {
                return <span>{minutes} <Translate id='minutes_ago' /></span>;
            }
        } else if (days < 1) {
            if (hours < 2) {
                return <Translate id='over_an_hour_ago' />;
            } else {
                return this.overXHoursAgo(hours);
            }
        } else if (days < 2) {
            return <Translate id='yesterday' />;
        } else {
            return <span>{days} <Translate id='days_ago' /></span>;
        }
    }

    render() {
        return (
            <span>
                {this.getTimeStamp(this.props.activityTime)}
            </span>
        )
    }
}